module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("fS7F0"))).then(() => parcelRequire('5WSiB'));